/**
 * @generated SignedSource<<b9c531f56cdc21cae55e9247efe52f80>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useHeaderProfileQuery$variables = {};
export type useHeaderProfileQuery$data = {
  readonly authenticatedInfo: {
    readonly isGuest: boolean;
    readonly isLoggedIn: boolean;
    readonly profile: {
      readonly sparkID: string;
      readonly lastName: string | null;
      readonly firstName: string | null;
      readonly loginOption: string;
    } | null;
  };
};
export type useHeaderProfileQuery = {
  variables: useHeaderProfileQuery$variables;
  response: useHeaderProfileQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AuthenticatedInfoResponse",
    "kind": "LinkedField",
    "name": "authenticatedInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isGuest",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isLoggedIn",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProfileInfo",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sparkID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "loginOption",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useHeaderProfileQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useHeaderProfileQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "259ece9cebe0409723219f2576338544",
    "id": null,
    "metadata": {},
    "name": "useHeaderProfileQuery",
    "operationKind": "query",
    "text": "query useHeaderProfileQuery {\n  authenticatedInfo {\n    isGuest\n    isLoggedIn\n    profile {\n      sparkID\n      lastName\n      firstName\n      loginOption\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "28b6f555d223e3a31725925f592adf5d";

export default node;
